"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentDeadline = exports.canCheckout = exports.getOrderUiStatus = exports.getIsPrePayment = exports.mergeCheckoutJStorageRespWithOrder = exports.getAdminUrlFromMergedCheckout = void 0;
var moment_1 = __importDefault(require("moment"));
var JStorage = __importStar(require("../Actions/JStorage"));
var Cart_1 = require("../Actions/Cart");
function getAdminUrlFromMergedCheckout(mergedCheckout, adminPrefix) {
  if (adminPrefix === void 0) {
    adminPrefix = '/admin';
  }
  if (mergedCheckout.__order_id) {
    return adminPrefix + "/order?action=detail&id=" + mergedCheckout.__order_id;
  } else {
    return adminPrefix + "/checkout?action=detail&id=" + mergedCheckout.id;
  }
}
exports.getAdminUrlFromMergedCheckout = getAdminUrlFromMergedCheckout;
function mergeCheckoutJStorageRespWithOrder(pagedCheckoutJStorageResp) {
  return __awaiter(this, void 0, void 0, function () {
    var orders, nextJStorageResult;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, JStorage.fetchDocuments('order', {
            $or: pagedCheckoutJStorageResp.results.map(function (r) {
              return {
                order_number: r.order_number
              };
            })
          }, null, null)];
        case 1:
          orders = _a.sent();
          nextJStorageResult = __assign(__assign({}, pagedCheckoutJStorageResp), {
            results: pagedCheckoutJStorageResp.results.map(function (checkout) {
              var order = orders.find(function (order) {
                return order.order_number === checkout.order_number;
              }) || {
                id: ''
              };
              return __assign(__assign(__assign({}, checkout), order), {
                id: checkout.id,
                __order_id: order.id
              });
            })
          });
          return [2 /*return*/, nextJStorageResult];
      }
    });
  });
}
exports.mergeCheckoutJStorageRespWithOrder = mergeCheckoutJStorageRespWithOrder;
function getIsPrePayment(order) {
  var payment_subtype = order.payment_subtype;
  return payment_subtype === Cart_1.PAYMENT_SUBTYPE.atm || payment_subtype === Cart_1.PAYMENT_SUBTYPE.credit || payment_subtype === Cart_1.PAYMENT_SUBTYPE.offline || payment_subtype === Cart_1.PAYMENT_SUBTYPE.default;
}
exports.getIsPrePayment = getIsPrePayment;
/*
先付款後出貨 宅配
UI	訂單狀態 ( 1 )	金流狀態 ( 2 )	物流狀態 ( 3 )
未付款	waiting	pending	x -
待處理	waiting	success / waiting	x - / pending
處理中	processing	x success	x - / pending /
已出貨	done	x success	center_delivered / in_delivery / delivered
已取消	canceled	x failure	x error / exception

先出貨後付款 超商取貨付款
UI	訂單狀態 ( 1 )	金流狀態 ( 3 )	物流狀態 ( 2 )
未付款	waiting	x pending	x - / pending
待處理	waiting	x pending	x - / pending
處理中	processing	x pending	x - / pending
已出貨	done	x pending	center_delivered / in_delivery / delivered
已取消	canceled	x failure	x error / exception
*/
function getOrderUiStatus(order) {
  var status = order.status,
    payment_status = order.payment_status,
    logistics_status = order.logistics_status;
  if (getIsPrePayment(order)) {
    if (status === Cart_1.ORDER_STATUS.canceled) {
      return Cart_1.ORDER_UI_STATUS.canceled;
    } else if (status === Cart_1.ORDER_STATUS.return_applied) {
      return Cart_1.ORDER_UI_STATUS.return_applied;
    } else if (status === Cart_1.ORDER_STATUS.return_completed) {
      return Cart_1.ORDER_UI_STATUS.return_completed;
    } else if (status === Cart_1.ORDER_STATUS.done || logistics_status === Cart_1.LOGISTICS_STATUS.center_delivered || logistics_status === Cart_1.LOGISTICS_STATUS.in_delivery || logistics_status === Cart_1.LOGISTICS_STATUS.delivered) {
      return Cart_1.ORDER_UI_STATUS.shipped;
    } else if (status === Cart_1.ORDER_STATUS.processing) {
      return Cart_1.ORDER_UI_STATUS.processing;
    } else if (payment_status !== Cart_1.PAYMENT_STATUS.success) {
      return Cart_1.ORDER_UI_STATUS.unpaid;
    } else if (status === Cart_1.ORDER_STATUS.waiting) {
      return Cart_1.ORDER_UI_STATUS.pending;
    } else {
      return Cart_1.ORDER_UI_STATUS.unknown;
    }
  } else {
    if (status === Cart_1.ORDER_STATUS.canceled) {
      return Cart_1.ORDER_UI_STATUS.canceled;
    } else if (status === Cart_1.ORDER_STATUS.return_applied) {
      return Cart_1.ORDER_UI_STATUS.return_applied;
    } else if (status === Cart_1.ORDER_STATUS.done || logistics_status === Cart_1.LOGISTICS_STATUS.center_delivered || logistics_status === Cart_1.LOGISTICS_STATUS.in_delivery || logistics_status === Cart_1.LOGISTICS_STATUS.delivered) {
      return Cart_1.ORDER_UI_STATUS.shipped;
    } else if (status === Cart_1.ORDER_STATUS.processing) {
      return Cart_1.ORDER_UI_STATUS.processing;
    } else {
      return Cart_1.ORDER_UI_STATUS.pending;
    }
  }
}
exports.getOrderUiStatus = getOrderUiStatus;
function canCheckout(checkout) {
  return !checkout.order_id && checkout.expired > new Date().getTime();
}
exports.canCheckout = canCheckout;
function getPaymentDeadline(order) {
  if (order.payment_subtype === 'credit' && !order.order_id) {
    return moment_1.default(order.expired).format('YYYY-MM-DD HH:mm');
  }
  if (order.payment_subtype === 'atm' && order.payment_status === 'code_generated') {
    return moment_1.default(order.pay_deadline).format('YYYY-MM-DD HH:mm');
  }
  return '-- --';
}
exports.getPaymentDeadline = getPaymentDeadline;